<template>
  <div class="spa-compat-bg">
    <div class="mx-auto max-w-[85rem] px-4 sm:px-6 lg:px-12">
      <slot></slot>
    </div>
  </div>
</template>

<style scoped>
  .spa-compat-bg {
    background-color: #f8fafc;
    min-height: 100vh;
  }
</style>
